import { ComponentHelper } from "../core/util/componentHelper";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { HTTPService } from "../core/util/httpManager";
import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { DropDownList } from "../core/components/dropDownList";
import { ToolBar } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { ReportDefinition } from "./reportMetaData";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";

export default class ValueGrid extends React.Component<ValueGridProps, ValueGridState> {
    private gridOptions: kendo.ui.GridOptions;
    private factory = ComponentHelper.createFactory();
    private values: KeyValuePair<number, string>[];
    private id: string;
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.add();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false, selected: null })
        },
        width: 500
    };

    constructor(props: ValueGridProps) {
        super(props);
        this.initApp();
        this.id = kendo.guid();
        this.state = {
            gridData: [],
            dialogOpen: false,
            selected: null,
            selectedId: null
        }
    }

    private onChange = () => {
        let lst = this.state.gridData.map((item) => { return item.id });
        this.props.onChange(this.props.field, lst);
    }

    private add = () => {
        let index = this.state.gridData.findIndex(f => f.id === this.state.selected);
        if (index === -1) {
            index = this.values.findIndex(f => f.Key === this.state.selected);
            let gridData = this.state.gridData;
            gridData.push({ value: this.values[index].Value, id: this.state.selected });
            this.setState({ gridData: gridData }, this.onChange)
        }
    }

    private remove = (id: number) => {
        let gridData = this.state.gridData.filter(f => f.id !== id);
        this.setState({ gridData: gridData, selectedId : null }, this.onChange)

    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "value",
                    title: this.props.field.label
                }
            ]
        };
        HTTPService.get(this.props.field.url).then((result) => {
            this.values = result;
            let gridData: { id: number; value: string }[] = [];
            let index: number;
            for (let i = 0; i < this.props.value.length; i++) {
                index = this.values.findIndex(f => f.Key === this.props.value[i]);
                gridData.push({ id: this.props.value[i], value: this.values[index].Value });
            }
            this.setState({ gridData: gridData});
        })

    }

    private createToolBar = () => {
        let customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "k-i-plus", id: "add" },
            { caption: Config.translations.delete, enabled: Helper.hasValue(this.state.selectedId), iconClass: "k-i-close", id: "remove" }
        ];
        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton}  />
            </>
        );
    }

    private createGrid = () => {
        const getFilter = () => {
            if (Helper.hasValue(this.state.selectedId)) {
                let item = this.state.gridData.find(f => f.id === this.state.selectedId);
                if (Helper.hasValue(item)) {
                    return item.value;
                }
            } 
            return null;
        }
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="reportMetaDataValueGrid"
                    onSelectionChanged={(data: { id: number }) => {
                        if (Helper.hasValue(data)) {
                            this.setState({ selectedId: data.id })
                        }
                    }}
                    selectFilter={getFilter()}
                />
            </div>
        );
    }

    private createReplacementText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className={`${this.props.field.icon} fa-10x`} style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.props.field.replacementText}
                    </label>
                </div>
            </div>
        );
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createDropDown()}
                </Dialog>
            </>
        );
    }

    private createDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.values;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.value = this.state.selected;
        props.onChange = (field, value) => {
            this.setState({ selected: value })
        }
        return (
            <>
                <FieldInstance label={this.props.field.label}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private handleClickCustomButton = (id: string) => {
        switch (id) {
            case "add":
                this.setState({ dialogOpen: true, selected: null })
                break;
            case "remove":
                this.remove(this.state.selectedId);
                break;
        }
    }

    render() {
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        const grid = (this.state.gridData.length > 0) ? this.createGrid() : this.createReplacementText();
        const toolBar = !this.props.disabled ? this.createToolBar() : null;
        return (
            <div id={this.id}>
                {toolBar}
                {grid}
                {dialog}
            </div>
        );
    }
}

interface ValueGridState {
    gridData: { id: number; value: string }[];
    dialogOpen: boolean;
    selected: number;
    selectedId: number;
}

interface ValueGridProps {
    value: number[];
    entity: ReportDefinition;
    onChange: (field, value) => void,
    disabled: boolean;
    field: {
        model: string,
        url: string,
        label: string,
        replacementText: string,
        icon: string
    }
    context: {
        translations: {}
    }
}